'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcLongTextOverflow
* @description
* # tcLongTextOverflow
* Logic for a displayonly element to clip the overflowed text display and add a toggle icon
*/
angular.module('tc.longTextOverflow', [])
.directive('tcLongTextOverflow', function($timeout, $window, $log, $mdUtil, GlobalService) {
	return {
		restrict: 'E',
		transclude: true,
		templateUrl: 'template/longTextOverflow/longTextOverflow.html',
		scope: {
			id: '@tcLongTextOverflowId',
			tcItemCaption: '@',
			tcListRowIndex: '=',
		},
		link: function(scope, element) {
			scope.viewModel = {
				showToggle: false,
				expanded: false,
			};
			scope.globalStrings = GlobalService.getGlobalStrings();
	
			scope.toggleLongText = function($event) {
				if ($event) $event.stopPropagation();
				scope.viewModel.expanded = !scope.viewModel.expanded;
			};
			
			// tc-long-text-overflow node is element[0];
			var longTextNode = element.children()[0];
			var longTextElement = angular.element(longTextNode);
			var contentNode = element.children().children()[1];
			
			var setupOverflow = function() {
				if (!longTextElement.hasClass('longTextOverflowCollapsed')) {
					longTextElement.addClass('longTextOverflowCollapsed');
				}
				var contentBounds = contentNode.getBoundingClientRect();
				var longTextBounds = longTextNode.getBoundingClientRect();
				var isOverflowing = ((contentBounds.height > longTextBounds.height) || (contentBounds.width > longTextBounds.width));
				scope.viewModel.showToggle = isOverflowing;
				if (!scope.viewModel.showToggle) {
					longTextElement.removeClass('longTextOverflowCollapsed');
				}
			};
			
			//allow time to render the content to determine if overflowed
			$timeout(function() {
				$mdUtil.nextTick(setupOverflow);
				angular.element($window).on('resize', setupOverflow);
			}, 0, false);
			
			scope.$onDestroy = function() {
				angular.element($window).off('resize', setupOverflow);
			};
		}
	};
});
